import type { DateRange, StudyType } from '../types/patientDetail';

export interface DateRangeParams {
  date_range?: string;
  study_date_from?: string;
  study_date_to?: string;
}

const DATE_RANGE_API_MAP: Record<
  Exclude<DateRange, 'custom'>,
  string | undefined
> = {
  all: undefined,
  last_30d: 'last_30_days',
  last_6m: 'last_6_months',
  last_1y: 'last_year',
};

export function mapDateRangeToApi(
  dateRange: DateRange,
  customDates: [string, string] | null = null
): DateRangeParams {
  if (dateRange === 'custom') {
    if (!customDates) return {};
    return { study_date_from: customDates[0], study_date_to: customDates[1] };
  }

  const value = DATE_RANGE_API_MAP[dateRange];
  return value ? { date_range: value } : {};
}

export function mapStudyTypeToApi(studyType: StudyType): string | undefined {
  return studyType === 'all' ? undefined : studyType;
}
